import React from "react";
import { gql } from "@apollo/client";

import { Typography } from "@mui/material";
import { PhoneMessage as PhoneCallIcon } from "mdi-material-ui";

const Icon = () => <PhoneCallIcon />;

const Title = () => <span>Appel téléphonique</span>;

const Content = ({ orderEvent }) => (
  <Typography style={{ whiteSpace: "pre-wrap" }}>
    {orderEvent.message}
  </Typography>
);

const fragments = {
  orderEvent: gql`
    fragment Orders_OrderEvent_PhoneCallEvent_OrderEvent on OrderEvent {
      id

      ... on OrderEvent_PhoneCall {
        message
      }
    }
  `,
};

const Event = {
  Icon,
  Title,
  Content,
  fragments,
};

export default Event;
